<template>
  <div :class="['template-collections q-mb-md']" ref="collectionDiv">
    <template
      v-if="
        component.collection?.seoName &&
        (products === false || products?.length > 0) &&
        !showEmptyCollection
      "
    >
      <AgeRestrictedBlur :isPreview="isPreview" :component="component" />

      <div
        :class="[
          'row items-start q-product-slider',
          productsInRow == 0 ? 'no-products' : '',
        ]"
      >
        <!--<div class="col-12">
        <h2 class="text-h5 q-mt-auto">
          {{ component.collectionTitle || component.collection?.name || '' }}
          <router-link
            class="link-primaryOnBody text-underline"
            :to="{
              name: 'Collection',
              params: { seoName: component.collection.seoName },
            }"
            v-if="products?.length > productsInRow"
          >
            See all
          </router-link>
        </h2>
      </div>-->
        <!-- v-if="productsInRow > 0" -->

        <Swiper
          :products="products"
          :productsInRow="productsInRow"
          :title="component.collectionTitle || component.collection?.name || ''"
          :seoName="component.collection.seoName"
        />

        <div v-if="!products?.length" class="col-12 full-height">
          <div class="row q-col-gutter-md q-mb-sm">
            <div class="col" v-for="n in productsInRow" :key="n">
              <q-card flat bordered class="q-width q-pa-sm">
                <q-skeleton width="100%" height="180px" class="q-mb-md" />
                <q-card-section
                  class="row no-wrap q-pt-sm q-pl-none q-pr-none q-pb-none"
                >
                  <div class="col">
                    <q-skeleton width="60%" height="15px" />
                  </div>
                  <div class="col-1">
                    <q-skeleton width="15px" height="15px" />
                  </div>
                </q-card-section>
                <q-card-section class="q-pt-sm q-pl-none q-pr-none q-pb-none">
                  <q-skeleton
                    type="text"
                    width="100%"
                    class="text-caption q-mt-sm"
                  />
                  <q-skeleton type="text" width="30%" class="text-caption" />
                </q-card-section>

                <q-card-section class="q-pt-none q-pl-none q-pr-none q-pb-none">
                  <q-skeleton width="40%" height="15px" class="q-mt-md" />
                </q-card-section>

                <q-card-actions class="q-pt-md q-pl-none q-pr-none q-pb-none">
                  <q-skeleton width="100%" type="QBtn" />
                </q-card-actions>
              </q-card>
            </div>
          </div>
        </div>
      </div>
    </template>
    <EmptyCollection
      v-if="showEmptyCollection"
      :title="component.collectionTitle || component.collection?.name || ''"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Swiper from 'components/Swiper'
import { swiperBreakpoints } from 'src/constants'
import { useHomePageStore } from 'src/stores/home-page'
import EmptyCollection from 'src/components/EmptyCollection.vue'
import { useCommonStore } from 'src/stores/common'
import { useAgeVerificationStore } from 'src/stores/age-verification'

const props = defineProps({
  component: {
    type: Object,
    default: () => ({}),
  },
  isPreview: {
    type: Boolean,
    default: false,
  },
})

const collectionDiv = ref(null)
const parentWidth = ref(0)
const homePageStore = useHomePageStore()
const showEmptyState = ref(false)
const commonStore = useCommonStore()
const ageVerificationStore = useAgeVerificationStore()
const showEmptyCollection = computed(() => {
  let isStoreAgeRestricted =
    commonStore.businessConfigurations?.isStoreAgeRestricted
  let isUserAgeVerified = ageVerificationStore.isUserAgeVerified
  let isAgeRestrictedBrowsingEnabled =
    commonStore.businessConfigurations?.enableAgeRestrictedBrowsing
  let isComponentAgeRestricted = props.component?.isAgeRestricted

  return (
    showEmptyState.value &&
    (!isStoreAgeRestricted || // if store not age Restricted then show
      isUserAgeVerified || // if user age Verified then show
      (isStoreAgeRestricted &&
        !isAgeRestrictedBrowsingEnabled &&
        !ageVerificationStore.skipBrowsingAgeRestrictedProd) || // ageRestricted Browsing Disabled and Store Age Restricted
      (isStoreAgeRestricted &&
        isAgeRestrictedBrowsingEnabled &&
        !isComponentAgeRestricted)) // age Restricted Browsing enabled and component Not Age Restricted
  )
})

const products = computed(() => {
  if (props.component?.collection?.id) {
    return homePageStore.getProductsByCollectionId(
      props.component.collection.id
    )
  }
  return false
})

const productsInRow = computed(() => {
  if (window?.innerWidth <= 600 && parentWidth.value >= 290) return 2

  let currentWidth = 0
  if (parentWidth.value) {
    for (let screenWidth in swiperBreakpoints) {
      if (screenWidth > parentWidth.value) {
        break
      }
      currentWidth = screenWidth
    }
  }

  return currentWidth ? swiperBreakpoints[currentWidth].elements : 0
})

const onParentResize = () => {
  parentWidth.value = collectionDiv.value?.clientWidth
    ? collectionDiv.value.clientWidth + 10
    : 0
}

onMounted(() => {
  if (props.component?.collection) {
    homePageStore
      .getProductsByCollection(props.component.collection)
      .then((data) => {
        if (!data?.items || data?.items?.length == 0) {
          showEmptyState.value = true
          /* homePageStore.updateHideComponent({
            compId: props.component.id,
            hide: true,
          }) */
        }
      })
  }

  parentWidth.value = collectionDiv.value?.clientWidth
    ? collectionDiv.value.clientWidth + 10
    : 0

  if (collectionDiv.value) {
    new ResizeObserver(onParentResize).observe(collectionDiv.value)
  }
})
</script>
